import { render, staticRenderFns } from "./SaveCollectionModal.vue?vue&type=template&id=9d197666&scoped=true&"
import script from "./SaveCollectionModal.vue?vue&type=script&lang=js&"
export * from "./SaveCollectionModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveCollectionModal.vue?vue&type=style&index=0&id=9d197666&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d197666",
  null
  
)

export default component.exports